import React, { ReactElement } from "react";
import {
  backgroundColorModeMapper,
  BackgroundColorWithMode,
} from "@kameleon-util/global-theme";
import { Box } from "theme-ui";
import {
  BlockTheme,
  BlockType,
  FCFooterBlock,
  FCFooterWidgetBlock,
} from "../typings";
import { ThemeableBlock } from "./themeable-block";
import {
  BlockAsProp,
  FooterBlockType,
  FooterWidgetBlockType,
} from "../typings/block-prop-types";

type FooterBlockConfig = {
  blockTheme: BlockTheme;
};

function footerBlock<T extends FooterBlockType>(
  config: FooterBlockConfig,
  RenderComponent: (props: T) => ReactElement
): FCFooterBlock<T> {
  const { blockTheme } = config;

  const block: FCFooterBlock<T> = (props: T): ReactElement => {
    const Component = RenderComponent(props);

    const className = "footer-primary--block";

    const propsAsAny = props as any;
    let themeMode = config.blockTheme;
    let backgroundColorWithMode: BackgroundColorWithMode | undefined;

    if (propsAsAny?.layoutProps?.backgroundColor) {
      backgroundColorWithMode = backgroundColorModeMapper(
        propsAsAny.layoutProps.backgroundColor
      );
      themeMode = backgroundColorWithMode.mode;
    }

    return (
      <ThemeableBlock
        blockType={BlockType.Footer}
        blockTheme={themeMode}
        backgroundColorWithMode={backgroundColorWithMode}
        className={className}
      >
        {Component}
      </ThemeableBlock>
    );
  };

  block.blockConfig = config;
  block.blockTheme = blockTheme;
  block.blockType = BlockType.Footer;

  return block;
}

/** FooterWidgetBlock section */
function footerWidgetBlock<T extends FooterWidgetBlockType>(
  RenderComponent: (props: T) => ReactElement
): FCFooterWidgetBlock<T> {
  const block: FCFooterWidgetBlock<T> = (props: T): ReactElement => {
    const Component = RenderComponent(props);
    return <Box className="footer__widget-block">{Component}</Box>;
  };

  block.blockType = BlockType.FooterWidget;
  return block;
}

const renderFooterWidgetBlock = (
  blockProp?: BlockAsProp
): null | ReactElement => {
  if (!blockProp || !blockProp.block) return null;
  return (
    <Box className="footer__widget-block">
      {React.createElement(
        blockProp.block,
        blockProp.props,
        blockProp.children
      )}
    </Box>
  );
};

export { footerBlock, footerWidgetBlock, renderFooterWidgetBlock };
export type { FooterBlockConfig };
